// Families shown in the icon switcher (double-click the gift icon).
// NOTE: these codes ship in the public site code, so anyone who finds the switcher
// or reads the page source can see every family's link. Edit this list when you
// add a family.
export const SWITCHER_FAMILIES = [
  { name: 'Mather Family', code: 'mather-k7m2x9qp' },
  { name: 'Johnson Family', code: 'johnson-family-6ffe5bcf17' }
];
